import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetStudentData, IGetStudentVars } from '../types';

export const GET_STUDENT: TypedDocumentNode<IGetStudentData, IGetStudentVars> = gql`
  query getStudent($input: ReadStudentInput!) {
    readStudent(input: $input) {
      absent
      accommodationsArray {
        code
        supplementalInfo
      }
      adultTestTakerFlag
      candDOB
      candFirstName
      candGender
      candLastName
      candMidInit
      candRegNo
      catapultId
      checkedInCenter
      checkedInRoom
      dapExamStatus {
        name
        timestamp
      }
      dapTestStatus {
        name
        payload {
          ... on DAPSectionStartTime {
            sectionName
          }
        }
        timestamp
      }
      deniedEntry
      displayedRegNo
      estimatedExamEndTime
      examStartTime
      grade8OrLowerFlag
      gradeLevel
      groupType
      id
      multiDayInd
      photoRequiredFlag
      photoUrl
      photoSrc
      photoThumbnailUrl
      room {
        capacity
        id
        groupTypes
        title
      }
      testDisplayName
      testPackageCount
      testPackageSeq
      specialUseOnly
      studentIds {
        studentId
        studentIdTypeCd
      }
      waitListFlag
    }
  }
`;
